import MGR from '../interceptors/MgrPublic';
import MGRAPI from '../interceptors/MgrApi';

const basePrivateUrl = '/clients/password-policy';

export const getClientPasswordPolicy = () => MGRAPI.get(basePrivateUrl);

export const createOrUpdateClientPasswordPolicy = (policies) => MGRAPI.post(
  basePrivateUrl,
  policies,
);

export const deleteClientPasswordPolicy = () => MGRAPI.delete(basePrivateUrl);

const basePublicUrl = '/password-policies';

export const getClientParametersByToken = (token) => MGR.get(`${basePublicUrl}/token/${token}`);

export const getDefaultPasswordPolicy = () => MGR.get(basePublicUrl);

export const DEFAULT_PASSWORD_POLICY = {
  MAX_INVALID_LOGIN_ATTEMPTS: 5,
  MIN_LENGTH: 8,
  MIN_LOWERCASE_CHARACTERS: 1,
  MIN_NUMERIC_CHARACTERS: 1,
  MIN_SPECIAL_CHARACTERS: 1,
  MIN_UPPERCASE_CHARACTERS: 1,
  PASSWORD_MAX_INACTIVITY_PERIOD: 30,
  PASSWORD_MAX_VALIDITY_PERIOD: 90,
};
